<div [class]="customClasses().formGroup">
    @if (secondaryLabel()) {
        <div class="row">
            <div class="col">
                <label [class]="customClasses().label">{{ label() }}</label>
            </div>
            <div class="col-auto">
                <small [class]="customClasses().secondaryLabel">{{ secondaryLabel() }}</small>
            </div>
        </div>
    } @else {
        <label [class]="customClasses().label" [class.disabled]="ngControl.disabled">
            {{ label() }}
            @if (inputRequiredIndicatorEnabled()) {
                <span class="text-danger"> *</span>
            }
        </label>
    }

    <textarea
        [class.is-invalid]="ngControl.touched && ngControl.invalid"
        [class]="customClasses().input"
        [formControl]="ngControl.control | formControl"
        [placeholder]="placeholder() ?? ''"
        [rows]="rows()"
        [attr.data-qa]="testAutomationSelectorName()"
    ></textarea>

    @if (ngControl.control?.errors?.['required']) {
        <div class="invalid-feedback d-block">{{ label() | titlecase }} cannot be empty</div>
    }

    @if (ngControl.control?.errors?.['minlength']) {
        <div class="invalid-feedback d-block">
            {{ label() }} must be at least {{ ngControl.control?.errors?.['minlength']['requiredLength'] }} characters
        </div>
    }

    @if (ngControl.control?.errors?.['maxlength']) {
        <div class="invalid-feedback d-block">
            {{ label() }} must be at most {{ ngControl.control?.errors?.['maxlength']['requiredLength'] }} characters
        </div>
    }

    @if (ngControl.control?.errors?.['pattern']) {
        <div class="invalid-feedback d-block">{{ label() }} does not follow the required format</div>
    }
</div>
